export function getStringField(
    resource: Record<string, unknown> | undefined,
    key: string,
): string | undefined {
    const value = resource?.[key];
    return typeof value === "string" ? value : undefined;
}

export function getNumberField(
    resource: Record<string, unknown> | undefined,
    key: string,
): number | undefined {
    const value = resource?.[key];
    return typeof value === "number" ? value : undefined;
}
